class EditorialCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initGallery();
  }

  initGallery() {
    const desktopOption = {
      type: "slide",
      perPage: 3,
      perMove: 1,
      gap: 32,
      pagination: false,
      arrows: true,
      keyboard: "focused",
      trimSpace: true,
      speed: 800,
      padding: {
        left: "60px",
        right: "60px",
      },
      breakpoints: {
        1199: {
          perPage: 2,
          gap: 20,
          padding: {
            left: "20px",
            right: "20px",
          },
        },
      },
    };
    const mobileOptions = {
      type: "slide",
      autoWidth: true,
      gap: 10,
      pagination: false,
      arrows: true,
      keyboard: "focused",
      trimSpace: true,
      speed: 800,
      padding: {
        left: "20px",
        right: "20px",
      },
    };

    initSplideWithAutoWidth(
      ".editorial-carousel",
      desktopOption,
      mobileOptions,
      "248px"
    );
  }
}

window.customElements.define("editorial-carousel", EditorialCarousel);
